var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('section',{staticClass:"fill-height",attrs:{"id":this.$route.params.uuid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }